import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Quote } from 'lucide-react';

const FounderMessage = () => {
  return (
    <>
      <Navigation />
      
      <div className="min-h-screen bg-sand pt-32">
        <div className="max-w-4xl mx-auto px-6 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-serif text-indigoDeep mb-4">Message from the Founder</h1>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 border border-goldSoft/20">
            <Quote className="w-12 h-12 text-goldSoft mb-6" />
            
            <div className="space-y-6 text-grayWarm leading-relaxed">
              <p>
                With over 11 years of experience and 7000+ in-depth chart analysis—including work with founders, sportspersons, Olympians, film industry professionals, and business leaders—I have seen astrology at its best when it is used responsibly and thoughtfully.
              </p>
              
              <p>
                At Mova Astro, astrology is not about fear, superstition, or fixed predictions. It is a structured system for understanding patterns—both within ourselves and in life—so we can make clearer, more conscious decisions.
              </p>
              
              <p>
                My own journey with astrology began as a search for clarity during uncertain phases of life. Over time, I learned that Vedic astrology, when applied with integrity, becomes a tool for self-awareness rather than dependency. This belief defines our approach at Mova Astro.
              </p>
              
              <p>
                We combine the depth of ancient Vedic wisdom with modern, practical thinking to offer ethical, personalized guidance. Whether you are in India or anywhere in the world, our intention is simple: to help you move forward with clarity and confidence.
              </p>
              
              <p className="text-indigoDeep font-medium">
                Thank you for trusting us.
              </p>
            </div>
            
            <div className="mt-8 pt-6 border-t border-goldSoft/30">
              <div className="text-right">
                <p className="text-indigoDeep font-semibold text-lg">— Preet Singh</p>
                <p className="text-grayWarm italic">Founder, Mova Astro</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default FounderMessage;